export function maskCep(value) {
    if (!value)
        return '';
    const numeric = value.replace(/\D/g, '');
    const limited = numeric.slice(0, 8);
    if (limited.length > 5) {
        return limited.replace(/^(\d{5})(\d{0,3})$/, '$1-$2');
    }
    return limited;
}
